import {
  getConfigInfo
} from './functions'
export default {
  data() {
    return {
      serverTime:{},
      timer:null,
      activeType:0,

      guessTime:[
        {name:'10万奖池',time:''},
        {name:'50万奖池',time:''},
        {name:'100万奖池',time:''}
      ],
      stopDrawTime:'',
      endTime:'',
      openTimes:[]
    }

  },
  created(){
  },
  mounted(){
    if (window.AlipayJSBridge) {
      ap.onResume(() => {
          this.getServerTime()
      })
    }
  },
  methods: {
    async getTimeInfo(){
      const res = await getConfigInfo.call(this)
      if (res.code === 0) {
        const other = res.data.other
        this.endTime= other.end_time.value
        this.openTimes = [other.top_16.value,other.top_4.value,other.top_1.value]
        this.$state.isShowContact = other.isShowContact.value
        this.$state.brandInfo = res.data
        Reflect.deleteProperty(this.$state.brandInfo,'other')
        this.$storejs.set(`${this.$key}brand`,this.$state.brandInfo)
        await this.getServerTime()
        if (this.timer > 0) {
           clearInterval(this.timer)
        }
        this.timer = setInterval(() => {
          this.serverTime = this.serverTime.add(1000,'millisecond')
        },1000)
      } else {
        this.$toast(res.msg)
      }
    },
    getDrawTime() {
      this.guessTime.map((item,index)=>{
        item.time = this.computeTime(this.openTimes[index])
      })
    },
    getStopTime(){
      this.stopDrawTime  = this.computeTime(this.endTime)
    },
    computeTime(openTime) {
      if (this.serverTime.diff(this.$dayjs(openTime)) > 0) {
        return 'end'
      }
      const diffTime = Math.abs(this.serverTime.diff(openTime))
      let $D = Math.floor(diffTime / 1000 / 60 / 60 / 24)
      let $H = Math.floor((diffTime / 1000 / 60 / 60) % 24)
      let $M = Math.floor((diffTime / 1000 / 60) % 60)
      let $s = Math.floor((diffTime / 1000) % 60)
      $D = $D < 10 ? `0${$D}` : `${$D}`
      $H = $H < 10 ? `0${$H}` : `${$H}`
      $M = $M < 10 ? `0${$M}` : `${$M}`
      $s = $s < 10 ? `0${$s}` : `${$s}`
      return `${$D}天${$H}:${$M}:${$s}`
    },
    async getServerTime(){
      if (window.AlipayJSBridge) {
        const res = await ap.getServerTime()
        this.serverTime = this.$dayjs(res.time)
      } else {
        this.serverTime = this.$dayjs()
      }
    }
  }
}
